import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (data) => {
	return fetch(Methods.DELETE, EndPoints.EXPENSE_DELETE.replace(':id', data.id), null, null, true);
};
